import { fetchQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
      
const query = graphql`
query AccountSpendingThisMonthFetchQuery($accountId: UUID!) {
  getaccountspendingthismonth2(accountid: $accountId) {
    spentThisMonth
    budget
  }
}
`;

function fetch(acctId) {
  const variables = {
    accountId: acctId
  }
  
  return fetchQuery(
    abEnvironment.getEnvironment(),
    query,
    variables
  );
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { fetch };

